import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatDialog,MAT_DIALOG_DATA,MatDialogRef } from  '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import {CommonService } from 'src/app/Global-Services/common.service';
import { AppTokenHandler, HTTPStatus } from 'src/app/Global-Services/app-token-handler';
import { HttpErrorResponse } from '@angular/common/http';
import * as FileSaver from 'file-saver';
import {ExcelUploadService} from 'src/app/Global-Services/excel-upload.service';
import { environment } from 'src/environments/environment';


export interface DialogData {
  userGPN: string;
  FTERecordsList: any;
  IsAdmin:boolean;
}

@Component({
  selector: 'app-fte-finance-uplod-pop-up',
  templateUrl: './fte-finance-uplod-pop-up.component.html',
  styleUrls: ['./fte-finance-uplod-pop-up.component.css'],
  providers: [CommonService],
  standalone: false,
})
export class FteFinanceUplodPopUpComponent implements OnInit {

  formData: FormData = new FormData();

  FTERecordUpload = {
  AttachmentName: '',
  AttachmentData: null,
  AttachmentID: 0,
  AttachmentList: [],
  ExcelFilePath:"",
};

ErrorMessage = [];


  constructor(public dialogRef: MatDialogRef<FteFinanceUplodPopUpComponent>, private _router: Router,
    private gservice: CommonService,  private dialog: MatDialog, public ExcelUpload: ExcelUploadService, private status: HTTPStatus,@Inject(MAT_DIALOG_DATA) public _data: DialogData,) { }

  ngOnInit() {

  }
  DeleteUploadedFile() {
  }

  UploadAttachment(event) {
    let type="FTEUploadFile";
    //this.FTERecordUpload.AttachmentList=null
    if (event.target.files.length > 0) {
      const fileList: FileList = event.target.files;
      const file: File = fileList[0];
      const maxLength = 1024 * 1024 * 5;
      const fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1);
      this.FTERecordUpload.AttachmentList.push({ 'AttachmentName': file.name, 'AttachmentID': 0, 'IsDeleted': false });
      this.FTERecordUpload.AttachmentName = file.name;

      if (fileExtension.toLowerCase() === 'xlsx') {
        this.formData = new FormData();
        if (event.target.files[0].size > maxLength) {
          alert('Filesize can not be more than 5 mb.');
          this.FTERecordUpload.AttachmentList = [];
          this.FTERecordUpload.AttachmentName = '';
          this.FTERecordUpload.AttachmentID = 0;
          return;
        }
        this.formData.append('Attachments', file, file.name);
        this.gservice.UploadAttachment(this.formData, 'FTEDetails/FTEUploadFile').subscribe(data => {
          if (data != null) {
            this.FTERecordUpload.ExcelFilePath = "";
            this.FTERecordUpload.ExcelFilePath = data;
          }
        });
      } else {
        alert('Please upload xlsx file.');
        this.formData = null;
        this.FTERecordUpload.AttachmentList = [];
        this.FTERecordUpload.AttachmentName = '';
        this.FTERecordUpload.AttachmentID = 0;
      }
    }
  }



DownloadFormat() {
  let ParamID;
  this.gservice.DownloadFTEUploadFormat(this._data.userGPN, ParamID, this._data.FTERecordsList, false, this._data.IsAdmin).subscribe((data: any) => {
    if (data != null) {
      if (data.length > 0) {
        this.ExcelUpload.exportAsExcelFile(data, 'FTEUploadFormat');
      }
    }
    },
    (err: HttpErrorResponse) => {
    this.gservice.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
    });
   this.gservice.RedirectToErrorPage(2);
  });
}


  submit()
  {
    this.ErrorMessage = [];
    if(this.FTERecordUpload.AttachmentList.length>0)
    {
      this.gservice.PostService({excelFilePath : this.FTERecordUpload.ExcelFilePath },'FTEDetails/VerifyUploadedFile').subscribe((data: any) => {
        if(data!=null && data.length>0)
        {   for (var i = 0; i > data.length; i++) {
          this.ErrorMessage.push({ message : data[i] });
        }
      }
      if (this.ErrorMessage.length > 0) {
        return;
      }
      else{
        this.gservice.PostService(this.FTERecordUpload, 'FTEDetails/SaveBulkFTEFinanceUpload').subscribe(data => {
          if(data.Table=="")
          {
            alert("Data Submitted Successfully!");
            this.closeDialog();
          this._router.navigate(['/View/ViewPendingForRenewal/5']);
          }
          else
          {
                  this.ExcelUpload.exportAsExcelFile(data.Table, 'FTEDetailsErrorFile');
          }

        },
          (err: HttpErrorResponse) => {
            this.gservice.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
            });
            this.gservice.RedirectToErrorPage(2);
          });

      }
      },
      (err: HttpErrorResponse) => {
        this.gservice.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gservice.RedirectToErrorPage(2);
      });

  }
}



  AttachmentList: any[];
  closeDialog() {
    this.dialog.closeAll();
  }


}
